import { Link } from 'react-router-dom';
import { sportArticles } from '@/mocks/sportsData';

export default function LatestNews() {
  const latestArticles = sportArticles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新体育资讯
            </h2>
            <p className="text-sm text-foreground-600">深度赛事分析、专家解读与行业动态</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latestArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-52 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-primary-500/90 text-background-50 px-2 py-0.5 rounded-full font-medium">
                    {article.category === 'football' ? '足球' : article.category === 'basketball' ? '篮球' : article.category === 'tennis' ? '网球' : article.category === 'esports' ? '电竞' : article.category === 'baseball' ? '棒球' : '赛车'}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-between flex-1">
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.summary}
                  </p>
                </div>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/70">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span>{article.publishDate}</span>
                    <span><i className="ri-eye-line mr-1"></i>{article.readCount.toLocaleString()}</span>
                  </div>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <Link
          to="/category/football"
          className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
        >
          更多文章 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}